import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _indexOf from 'lodash/indexOf';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Models
import mDoor from 'models/door';
// Custom
import { deviceSlaveRelayDataShape, doorDataShape } from 'constants/PropTypesShapes';
import DoorItem from 'installations/assets/configuration/DoorItem';

class ConfigureDeviceSlaveRelay extends React.Component {
  constructor(props) {
    super(props);

    this.handleDoorChange = this.handleDoorChange.bind(this);
  }

  // Handlers
  handleDoorChange(door) {
    const { relay: { doors } } = this.props;
    // Try to find door id in relay doors
    const doorIndex = _indexOf(doors, door.id);
    let newDoors = [];
    if (doorIndex === -1) {
      newDoors = [...doors, door.id];
    } else {
      newDoors = [...doors.slice(0, doorIndex), ...doors.slice(doorIndex + 1)];
    }
    this.doHandleDoorChange(newDoors);
  }

  // Private
  doHandleDoorChange(doors) {
    const { relay, onRelayDoorChange } = this.props;
    onRelayDoorChange(relay, doors);
  }

  render() {
    const { relay, installationDoors } = this.props;
    const { doors } = relay;
    const sortedDoors = mDoor.sortElements(installationDoors);

    return (
      <div className="box box-default m-0">
        <div className="box-header box-dark">
          <LocalizedMessage id="info.relay" values={{ relay: relay.code }} />
        </div>
        <div className="px-3">
          {_isEmpty(sortedDoors) && (
            <div className="pt-3">
              <em><LocalizedMessage id="info.installationNoDoor" /></em>
            </div>
          )}
          <div className="row pb-3">
            {!!installationDoors && _map(sortedDoors, (door) => (
              <div key={_toString(door.id)} className="col-12">
                <DoorItem
                  door={door}
                  toggle={
                    { toggled: _includes(doors, door.id), onToggle: () => this.handleDoorChange(door) }
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

ConfigureDeviceSlaveRelay.propTypes = {
  relay: deviceSlaveRelayDataShape.isRequired,
  installationDoors: PropTypes.arrayOf(doorDataShape),
  onRelayDoorChange: PropTypes.func.isRequired,
};

ConfigureDeviceSlaveRelay.defaultProps = {
  installationDoors: null,
};

const mapStateToProps = (state) => ({
  installationDoors: state.installationDoor.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ConfigureDeviceSlaveRelay);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/ConfigureDeviceSlaveRelay.js